import React, { Component } from 'react'

import { getHomePageArticle } from './articles/index'
import './Content.css'

export default class Content extends React.Component {
  constructor(props) {
    super(props)
    this.state = { article: "" }
  }

  componentDidMount() {
    getHomePageArticle()
      .then(text => {
        this.setState({
          article: text
        })
      })
      .catch(e => {
        console.log("getHomePageArticle failed", e)
      })
  }

  render() {
    return (
      <div
        className="content"
        dangerouslySetInnerHTML={{
          // __html: convert(this.state.article)
          __html: this.state.article
        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/Content.js